import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useAlert } from "react-alert";
export const KAlert = (props) => {
    const alert = useAlert();
    const { msg, type, hidden } = props;
    useEffect(() => {
        if (msg) {
            alert.show(msg, {
                type: type || "info",
            });
        }
    }, [alert, msg, type, hidden]);
    return _jsx(_Fragment, {});
};
